/**
 * Registers the RLGSP icon sprite with the map — wired into
 * `nswRlgspConfig.map.onLoad`.
 *
 * The sprite artifacts are served from `static` (`sprite.json`,
 * `sprite.png` and the `@2x` variants — see the README in that folder for how
 * to regenerate them). Symbol layers in `layer_styles/` reference icons
 * namespaced by the sprite id declared here, e.g.
 * `"icon-image": "<RLGSP_SPRITE_ID>:school-zone"`.
 */

import type { Map } from 'maplibre-gl';

// The `{id}:` prefix used by `icon-image` in layer-style JSON.
const RLGSP_SPRITE_ID = 'rlgsp';

// Root-relative path of the sprite artifacts — also read directly by the
// legend's `SpriteIcon` to render icon swatches outside the map.
export const RLGSP_SPRITE_PATH = '/sprites/speedmanagement/sprite';

export const loadRlgspSprite = (map: Map) => {
	// Sprite URLs must be absolute, hence location.origin. MapLibre fetches the
	// .json/.png (and @2x) artifacts itself, picking the right pixel ratio.
	map.addSprite(RLGSP_SPRITE_ID, `${location.origin}${RLGSP_SPRITE_PATH}`);
};
